import { createContext } from "react"
import useProjects from "../../hooks/data/useProjects";

export interface IProjectsContext extends ReturnType<typeof useProjects> {
}

export const ProjectsContext = createContext<IProjectsContext>({
    data: undefined,
    idMap: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ProjectsContext;